import { ExternalLink } from 'lucide-react';
import { socialUrl, socialDisplay } from '@/utils/socials';

// Live confirm-link under a social input: shows exactly where the typed handle
// points and opens it in a new tab so the stylist verifies it's their account.
export default function SocialLinkPreview({ network, value }) {
  const url = socialUrl(network, value);
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="mt-1 inline-flex items-center gap-1 text-xs text-primary/80 hover:text-primary hover:underline"
    >
      <ExternalLink className="h-3 w-3 shrink-0" />
      {socialDisplay(network, value)} — tap to confirm it's you
    </a>
  );
}
